import { Box } from '@mui/material';
import { LegalDocumentEditor } from '@provision/legal-document-ui';
import { Controller } from 'react-hook-form';
import type { LegalDocumentSurface } from 'src/pages/Settings/memberships/hooks/use-legal-document-surface';

interface LegalDocumentPageProps {
  surface: LegalDocumentSurface;
}

export const LegalDocumentPage = ({ surface }: LegalDocumentPageProps) => {
  const { control, setValue } = surface.formMethods;

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        width: '100%',
        overflow: 'auto',
        borderRadius: 1,
        bgcolor: 'background.paper',
      }}
    >
      <Controller
        name="title"
        control={control}
        render={({ field }) => (
          <LegalDocumentEditor
            key={surface.formKey}
            title={field.value}
            onTitleChange={field.onChange}
            bodyHtml={surface.data.bodyHtml}
            onBodyChange={(bodyHtml) => setValue('bodyHtml', bodyHtml, { shouldDirty: true })}
            updatedAt={surface.savedDocument?.updatedAt ?? null}
          />
        )}
      />
    </Box>
  );
};
